import React from "react";
import { cn } from "../../lib/utils";

interface ActionButtonProps {
  label: string;
  onPress: () => void;
  color?: string;
  className?: string;
  textClassName?: string;
  leftIcon?: React.ReactNode;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
}

export default function ActionButton({
  label,
  onPress,
  color,
  className,
  textClassName,
  leftIcon,
  disabled = false,
  type = "button",
}: ActionButtonProps) {
  const hasLabel = label.trim().length > 0;

  return (
    <button
      type={type}
      onClick={onPress}
      disabled={disabled}
      className={cn(
        "inline-flex items-center justify-center rounded-full border border-[#d1d5db] bg-white px-[14px] py-2 text-sm font-semibold text-slate-800 transition-colors disabled:cursor-not-allowed disabled:opacity-60",
        className
      )}
      style={color ? { backgroundColor: color } : undefined}
    >
      <span className="inline-flex items-center">
        {leftIcon ? (
          <span className={cn("inline-flex", hasLabel ? "mr-1.5" : "")}>
            {leftIcon}
          </span>
        ) : null}
        {hasLabel ? <span className={cn(textClassName)}>{label}</span> : null}
      </span>
    </button>
  );
}
